module.exports = __webpack_public_path__ + "static/media/icon-pro-auditing.4fc2bf39.svg";